import React, {Component} from "react";

export default function DescriptionBlock({ dataDescription }){
    let data = dataDescription ? dataDescription[0] : null;
    return ( <div className="page-career-description">
            {data && data.title ? <span className="career-description-title" dangerouslySetInnerHTML={{__html: data.title}} /> : null}
            {data && data.text ? <span className="career-description-txt" dangerouslySetInnerHTML={{__html: data.text}} /> : null}
        </div>
    )
}